/* Seneca Etsy reviews — horizontal slider controls */
(() => {
  const init = () => {
    document.querySelectorAll('[data-seneca-reviews-slider]').forEach((slider) => {
      if (slider.dataset.senecaReviewsReady === 'true') return;
      const track = slider.querySelector('[data-seneca-review-track]');
      const cards = track ? Array.from(track.querySelectorAll('.seneca-etsy-review')) : [];
      const previous = slider.querySelector('[data-seneca-review-prev]');
      const next = slider.querySelector('[data-seneca-review-next]');
      const position = slider.querySelector('[data-seneca-review-position]');
      if (!track || !cards.length || !previous || !next) return;
      slider.dataset.senecaReviewsReady = 'true';
      const step = () => cards[0].getBoundingClientRect().width + parseFloat(getComputedStyle(track).gap || '0');
      const update = () => {
        const maxScroll = Math.max(0, track.scrollWidth - track.clientWidth);
        const current = Math.min(cards.length, Math.max(1, Math.round(track.scrollLeft / Math.max(1, step())) + 1));
        previous.disabled = track.scrollLeft <= 2;
        next.disabled = track.scrollLeft >= maxScroll - 2;
        if (position) position.textContent = current + ' / ' + cards.length;
      };
      previous.addEventListener('click', () => track.scrollBy({ left: -step(), behavior: 'smooth' }));
      next.addEventListener('click', () => track.scrollBy({ left: step(), behavior: 'smooth' }));
      track.addEventListener('scroll', () => window.requestAnimationFrame(update), { passive: true });
      track.addEventListener('keydown', (event) => { if (event.key === 'ArrowLeft') { event.preventDefault(); track.scrollBy({ left: -step(), behavior: 'smooth' }); } if (event.key === 'ArrowRight') { event.preventDefault(); track.scrollBy({ left: step(), behavior: 'smooth' }); } });
      window.addEventListener('resize', update, { passive: true });
      update();
    });
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init, { once: true }); else init();
})();
